module.exports = __webpack_public_path__ + "static/img/1 五粮液春节.641d459.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1 五粮液春节.png
// module id = r5Fn
// module chunks = 1